import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Stack,
  CircularProgress,
} from "@mui/material";
import BaseButton from "../../UI/BaseButton/BaseButton";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { commonRunQuery, GetUserExternalRef, DeleteUserExternalRef } from "../../../util/API/loans";

export default function ReEnableMFA() {
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "",
    message: "",
    header: "",
  });

  const handleReEnableMFA = async () => {
    setLoading(true);
    try {
            // Step 1: Get userId from username
      const userResponse = await commonRunQuery(358, username);
      console.log("getUserByUsername response============", userResponse);

      if (userResponse?.data?.header?.callStatus != "1" || userResponse?.data?.header?.reccount === "0") {
        setAlert({ showAlert: true, severity: "error", message: "User not found", header: "Error" });
        return;
      }

      const record = Array.isArray(userResponse?.data?.body?.record)
        ? userResponse?.data?.body?.record
        : [userResponse?.data?.body?.record];

      // === NEW: Strict check for 4pay.me domain in returned record ===
      const userAccount = record[0]?.useremailaccount;
      const returnedUsername = (userAccount?.username || 
                                userAccount?.emailAccount || 
                                userAccount?.useremail || 
                                userAccount?.email || 
                                '').toString().toLowerCase().trim();

      const has4payDomain = returnedUsername.endsWith('@4pay.me');   // <-- checks exactly for 4pay.me

      const inputHadDomain = username.includes('@');

      

      if (!has4payDomain && !inputHadDomain) {
        setAlert({ showAlert: true, severity: "error", message: "User not found", header: "Error" });
        return;
      }
      // === END OF 4pay.me DOMAIN CHECK ===

      const userId = record[0]?.useremailaccount?.userID;
      console.log("userId============", userId);

      if (!userId) {
        setAlert({ showAlert: true, severity: "error", message: "Could not retrieve user ID", header: "Error" });
        return;
      }

      // Step 2: Get refId from external ref (exttype hardcoded to 19)
      const externalRefResponse = await GetUserExternalRef(userId, "19");
      console.log("GetUserExternalRef response============", externalRefResponse);

      const refid = externalRefResponse?.data?.body?.refid;
      console.log("refid============", refid);

      if (!refid) {
        setAlert({ showAlert: true, severity: "error", message: "No MFA record found for this user", header: "Error" });
        return;
      }

      // Step 3: Delete the external ref
      const deleteResponse = await DeleteUserExternalRef(refid);
      console.log("DeleteUserExternalRef response============", deleteResponse);

      if (deleteResponse?.data?.header?.callStatus == "1") {
        setAlert({ showAlert: true, severity: "success", message: `MFA successfully re-enabled for user: ${username}`, header: "Success" });
        handleClear();
      } else {
        setAlert({ showAlert: true, severity: "error", message: deleteResponse?.data?.header?.msg || "Failed to re-enable MFA", header: "Error" });
      }

    } catch (err) {
      console.error("handleReEnableMFA error============", err);
      setAlert({ showAlert: true, severity: "error", message: "An unexpected error occurred", header: "Error" });
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setUsername("");
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#f5f5f5", padding: "16px" }}>
      <Box sx={{ backgroundColor: "#ffffff", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", width: "600px", padding: "24px", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Typography variant="h6" sx={{ marginBottom: "16px", color: "#333333", fontWeight: "bold" }}>
          Re-Enable MFA
        </Typography>

        <Stack spacing={2} width="100%">
          <TextField
            label="Username"
            fullWidth
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            disabled={loading}
          />

          <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} mt={2}>
            <BaseButton buttonText={"Clear"} onClick={handleClear} disabled={loading} />
            <BaseButton
              buttonText={"Re-Enable MFA"}
              onClick={handleReEnableMFA}
              disabled={!username.trim() || loading}
            />
            {loading && <CircularProgress size={24} />}
          </Stack>

          <Typography variant="body2" align="center" sx={{ mt: 3, fontStyle: "italic", color: "#555" }}>
            Enter a username to re-enable MFA access
          </Typography>
        </Stack>
      </Box>

      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={(prev) => setAlert({ ...prev, showAlert: false })}
        autoclose={alert.severity === "error" ? false : true}
      />
    </Box>
  );
}